import Quill from 'quill';

interface IPlaceholderValue {
  value: string;
  label: string;
}

const Inline = Quill.import('blots/inline');

class Placeholder extends Inline {
  static create({
    value,
    label,
  }: IPlaceholderValue): Node {
    const node = super.create();
    node.dataset.value = value;
    node.dataset.label = label;
    node.setAttribute('contenteditable', false);
    return node;
  }

  value(node: HTMLElement): IPlaceholderValue {
    return {
      value: node.dataset.value ?? '',
      label: node.dataset.label ?? '',
    };
  }

  static formats(node: HTMLElement): IPlaceholderValue {
    return {
      value: node.dataset.value ?? '',
      label: node.dataset.label ?? '',
    };
  }

  optimize(): void {
  }

  deleteAt(): void {
    this.remove();
  }
}
Placeholder.blotName = 'placeholder';
Placeholder.className = 'pointage-placeholder';
Placeholder.tagName = 'SPAN';

export default Placeholder;
